module.exports = __webpack_public_path__ + "img/43.7bb342d7.svg";